<template>
    <section class="header">
        <van-search
            v-model.trim.lazy="value"
            placeholder="请输入搜索内容"
            background="transparent"
            @search="onSearch"
        >
            <div
                slot="action"
                @click="onSearch"
            >搜索</div>
            <template #left-icon>

                <van-icon
                    size="20"
                    :name="require('@/assets/search.png')"
                ></van-icon>

            </template>
        </van-search>

        <van-list
            v-show="value"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getList"
        >
            <van-cell
                v-for="item in posts"
                :key="item.id"
                is-link
                :url="item.link.replace('mhelp','help')"
                :title="item.title.rendered"
            />

        </van-list>
    </section>
</template>

<script>
import { Search, Toast, Cell, List, Icon } from "vant";
export default {
    components: {
        "van-search": Search,
        "van-list": List,
        "van-cell": Cell,
        "van-icon": Icon
    },
    data () {
        return {
            loading: false,
            finished: false,
            page: 1,
            value: this.$route.query.search || null,
            id: this.$route.query.categories,
            posts: []
        };
    },
    watch: {
        value (val) {
            if (this.time) {
                clearTimeout(this.time);
            }
            if (!val) {
                return;
            }
            this.time = setTimeout(() => {
                this.clearSearch();
                this.onSearch();
            }, 500);
        }
    },
    methods: {
        clearSearch () {
            this.posts = [];
            this.page = 1;
            this.finished = false;
            return;
        },
        async onSearch () {
            if (!this.value) {
                Toast("请输入搜索内容");
                return;
            }
            // if (this.$route.name === "search") {
            //   this.posts = [];
            //   this.page = 1;
            //   this.finished = false;
            //   return;
            // }
            // this.$router.push({
            //   name: "search",
            //   query: { categories: this.id, search: this.value }
            // });
            this.getList();
        },
        async getList () {
            let data = await this.$http
                .get(
                    "/wp-json/wp/v2/posts?categories=" +
                    this.id +
                    "&search=" +
                    this.value +
                    "&order=asc" +
                    "&page=" +
                    this.page++
                )
            // .catch((e) => {
            //     Toast(e.message)
            // });

            if (!data || data.length <= 0) {
                this.loading = false;
                this.finished = true;
                return;
            }
            // 加载状态结束
            this.loading = false;

            this.posts = this.posts.concat(data);
            if (data.length < 10) {
                this.finished = true;
            }
        }
    }
};
</script>
 

<style >
.header {
    padding-bottom: 20px !important;
}
.header input::placeholder {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
}
.header .van-field__left-icon {
    display: flex;
    align-items: center;
    padding: 0px 0px 0px 10px;
}
.header input {
    font-size: 28px;
}
.header .van-search__content {
    background-color: transparent;
    padding: 0px;
}
.header .van-cell--borderless {
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    border-radius: 8px;
}
@media screen and (min-width: 768px) {
    .header input {
        font-size: 18px !important;
    }
    .header input::placeholder {
        font-size: 18px !important;
    }
}
</style>